import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/cover',
        name: 'cover',
        component: () => import('@/views/Cover.vue')
    },
    {
        path: '/end',
        name: 'end',
        component: () => import('@/views/End.vue')
    },
    {
        path: '/fail',
        name: 'fail',
        component: () => import('@/views/Fail.vue')
    },
    {
        path: '/:code',
        name: 'home',
        component: Home
    },
    {
        path: '*',
        name: '404',
        component: () => import('@/views/404.vue')
    }
];
const router = new VueRouter({
    mode: 'hash',
    routes
});

/**
 * 路由守卫 - 检查登录状态
 * 如果 from 的 query中有secaccount字段，将secaccount赋值给to的query.secaccount
 */
router.beforeEach((to, from, next) => {
    const secaccount = from.query.secaccount;
    // 关键判断：只有 来源有参数 + 目标没有参数 时，才重定向
    if (secaccount && !to.query.secaccount) {
        next({ ...to, query: { ...to.query, secaccount: secaccount } });
    } else {
        next();
    }
});

export default router;
